import { createContext, useState } from "react";

export const EducationContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [educations, setEducations] = useState([]);

    // Make the context object:
    const educationContext = {
        educations,
        setEducations,
    };

    // pass the value in provider and return
    return <EducationContext.Provider value={educationContext}>{children}</EducationContext.Provider>;
};

export const { Consumer } = EducationContext;
